export class FileUtil {
  static allowedFormats = ["image/jpeg", "image/png", "image/bmp"];
  static compressionQuality = 0.1;
  static maxWidth = 2000;

  static toWebp = (file) => {
    return new Promise((resolve) => {
      if (!this.allowedFormats.includes(file.type)) {
        resolve(file);
        return;
      }
      const reader = new FileReader();
      reader.onload = function (e) {
        const img = new Image();
        img.onload = function () {
          let width = img.width;
          let height = img.height;
          if (width > FileUtil.maxWidth) {
            const scaleFactor = FileUtil.maxWidth / width;
            width = FileUtil.maxWidth;
            height = height * scaleFactor;
          }
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob(
            (blob) => {
              if (blob) {
                const webpFile = new File(
                  [blob],
                  file.name.replace(/\.[^/.]+$/, ".webp"),
                  {
                    type: "image/webp",
                    lastModified: Date.now(),
                  }
                );
                resolve(webpFile);
              } else {
                resolve(file);
              }
            },
            "image/webp",
            FileUtil.compressionQuality
          );
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  static toWebpMultiple = (files) => {
    return Promise.all(files.map((file) => this.toWebp(file)));
  };
}
